import React from 'react';
import { SelectState } from './types';

export const SelectContext = React.createContext<SelectState | null>(null);
